import { render } from "./EventSummary.vue?vue&type=template&id=ce397264&scoped=true"
import script from "./EventSummary.vue?vue&type=script&lang=js"
export * from "./EventSummary.vue?vue&type=script&lang=js"

import "./EventSummary.vue?vue&type=style&index=0&id=ce397264&scoped=true&lang=scss"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce397264"]])

export default __exports__